export default "__VITE_ASSET__Dm4j2xaU__"